import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyBHKNOzeiboeI7O9XoZgKccR5o3Ko1dJSM",
  authDomain: "service24-b9d2c.firebaseapp.com",
  projectId: "service24-b9d2c",
  storageBucket: "service24-b9d2c.firebasestorage.app",
  messagingSenderId: "144551736284",
  appId: "1:144551736284:web:6c2601ebecb5fef8901519",
  measurementId: "G-0V167080Z3"
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export const requestForToken = async () => {
  try {
    const permission = await Notification.requestPermission();
    if (permission === "granted") {
      const token = await getToken(messaging, {
        vapidKey: "BFUfQf6-lVqPm6X9Ob-joUIyC3gWNKEWPWzWreOaax373PtK8VfCS1FprG6FhiMIokh4-sju2Jql9dytCugdgBI",
      });
      if (token) {
        return token;
      } else {
        console.log("No registration token available. Request permission to generate one.");
      }
    }
  } catch (err) {
    console.error("An error occurred while retrieving token. ", err);
  }
};

export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      console.log("Foreground Message received: ", payload);
      resolve(payload);
    });
  });

export default app;
